import MultiCityForPhone from "components/MultiCityForPhone/MultiCityForPhone";
import OneWayForPhone from "components/OneWayForPhone/OneWayForPhone";
import RoundTripFormForPhone from "components/RoundTripFormForPhone/RoundTripFormForPhone";
import React, { useState } from "react";

const options = [
  {
    label: "India",
    options: [
      {
        value: "Indira Gandhi International Airport (New Delhi)",
        label: "Indira Gandhi International Airport (New Delhi)",
      },
      {
        value: "Chhatrapati ShairpotsFromivaji International Airport (Mumbai)",
        label: "Chhatrapati Shivaji International Airport (Mumbai)",
      },
      {
        value: "Kempegowda International Airport (Bengaluru)",
        label: "Kempegowda International Airport (Bengaluru)",
      },
      {
        value: "Rajiv Gandhi International Airport (Hyderabad)",
        label: "Rajiv Gandhi International Airport (Hyderabad)",
      },
      {
        value: "Chennai International Airport (Chennai)",
        label: "Chennai International Airport (Chennai)",
      },
      {
        value: "Netaji Subhas Chandra Bose International Airport (Kolkata)",
        label: "Netaji Subhas Chandra Bose International Airport (Kolkata)",
      },
      {
        value: "Sardar Vallabhbhai Patel International Airport (Ahmedabad)",
        label: "Sardar Vallabhbhai Patel International Airport (Ahmedabad)",
      },
      {
        value: "Cochin International Airport (Kochi)",
        label: "Cochin International Airport (Kochi)",
      },
      {
        value: "Dabolim Airport (Goa)",
        label: "Dabolim Airport (Goa)",
      },
      {
        value: "Pune Airport (Pune)",
        label: "Pune Airport (Pune)",
      },
    ],
  },
  {
    label: "🍁 Canada",
    options: [
      {
        value: "Calgary International Airport",
        label: "Calgary International Airport",
      },
      {
        value: "Edmonton International Airport",
        label: "Edmonton International Airport",
      },
      {
        value: "Fredericton International Airport",
        label: "Fredericton International Airport",
      },
      {
        value: "Gander International Airport",
        label: "Gander International Airport",
      },
      {
        value: "Halifax Stanfield International Airport",
        label: "Halifax Stanfield International Airport",
      },
      {
        value: "Greater Moncton Roméo LeBlanc International Airport",
        label: "Greater Moncton Roméo LeBlanc International Airport",
      },
      {
        value: "Montréal–Trudeau International Airport",
        label: "Montréal–Trudeau International Airport",
      },
      {
        value: "Ottawa Macdonald–Cartier International Airport",
        label: "Ottawa Macdonald–Cartier International Airport",
      },
      {
        value: "Québec/Jean Lesage International Airport",
        label: "Québec/Jean Lesage International Airport",
      },
      {
        value: "St. John's International Airport",
        label: "St. John's International Airport",
      },
      {
        value: "Toronto Pearson International Airport",
        label: "Toronto Pearson International Airport",
      },
      {
        value: "Vancouver International Airport",
        label: "Vancouver International Airport",
      },
      {
        value: "Winnipeg International Airport",
        label: "Winnipeg International Airport",
      },
    ],
  },
  {
    label: "America",
    options: [{ value: "America", label: "America" }],
  },
];

export default function FlightSearchComponent() {
  const [round, setRound] = useState(true);
  const [oneWay, setOneWay] = useState(false);
  const [multiCity, setMultiCity] = useState(false);
  const [airport, setAirport] = useState([]);

  // const getAirport = async () => {
  //   const params = {
  //     iata: "NDS",
  //   };
  //   try {
  //     const res = await userResources.airport(params);
  //     console.log(res);
  //   } catch (error) {
  //     console.error("Failed to fetch airport data:", error);
  //   }
  // };

  // useEffect(() => {
  //   getAirport();
  // }, []);

  return (
    <div className="rounded-lg border border-red-200  md:col-span-1">
      <div className="sticky top-0  p-3">
        <h2 className="text-2xl font-bold text-gray-900">
          Book Flight Tickets
        </h2>
        <fieldset className="flex gap-2">
          <div
            className="flex items-center gap-2 rounded-full border  px-3 py-0.5 text-sm"
            onClick={() => {
              setRound(true);
              setMultiCity(false);
              setOneWay(false);
            }}
          >
            <div
              className={`h-4 w-4 rounded-full border-2 border-red-200 ${
                round === true ? "bg-red-400" : ""
              }`}
            ></div>

            <label
              htmlFor="roundTrip"
              className="cursor-pointer whitespace-nowrap"
            >
              Round Trip
            </label>
          </div>
          <div
            className="flex items-center gap-2 rounded-full border  px-2 py-0.5 text-sm"
            onClick={() => {
              setRound(false);
              setMultiCity(false);
              setOneWay(true);
            }}
          >
            <div
              className={`h-4 w-4 rounded-full border-2 border-red-200 ${
                oneWay === true ? "bg-red-400" : ""
              }`}
            ></div>
            <label
              htmlFor="oneWay"
              className="cursor-pointer whitespace-nowrap"
            >
              One Way
            </label>
          </div>

          <div
            className="flex items-center gap-2 rounded-full border  px-3 py-0.5 text-sm"
            onClick={() => {
              setRound(false);
              setMultiCity(true);
              setOneWay(false);
            }}
          >
            <div
              className={`h-4 w-4 rounded-full border-2 border-red-200 ${
                multiCity === true ? "bg-red-400" : ""
              }`}
            ></div>

            <label
              htmlFor="multiCity"
              className="cursor-pointer whitespace-nowrap"
            >
              Multi City
            </label>
          </div>
        </fieldset>
        <div className="mt-2">
          {round === true ? (
            <RoundTripFormForPhone options={options} />
          ) : oneWay === true ? (
            <OneWayForPhone options={options} /> // Render OneWayForPhone for one-way trip
          ) : multiCity === true ? (
            <MultiCityForPhone options={options} /> // Render MultiCityForPhone for multi-city
          ) : null}
        </div>
      </div>
    </div>
  );
}
